let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2goda")).then(() => parcelRequire('iOI8t'));